import apiClient from "../api/apiClient";

class ShortLinkService {
  private baseApiUrl = process.env.REACT_APP_BACKEND_API;

  async fetchOriginalUrl(shortCode: string): Promise<{ originalUrl: string }> {
    try {
      const response = await apiClient.get<{ originalUrl: string }>(
        `${this.baseApiUrl}/api/short-links/${shortCode}`,
      );
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch original URL");
    }
  }
}

export const shortLinkService = new ShortLinkService();
